var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M16.122 4.63518L15 5.57411V3.91614L15.942 4.51039C16.0042 4.54885 16.0642 4.5905 16.122 4.63518ZM16.752 5.66324L15 7.13105L9.558 11.6949C9.35312 11.8598 9.11622 11.9811 8.862 12.0515C8.76111 12.0751 8.65894 12.0929 8.556 12.105H8.244C8.14105 12.0929 8.03889 12.0751 7.938 12.0515C7.686 11.9831 7.45106 11.8637 7.248 11.7009L1.8 7.13105L0.048 5.66324C0.019855 5.77817 0.00376971 5.89566 0 6.01385V14.8564C0 15.3292 0.189642 15.7826 0.527208 16.117C0.864773 16.4513 1.32261 16.6391 1.8 16.6391H15C15.4774 16.6391 15.9352 16.4513 16.2728 16.117C16.6104 15.7826 16.8 15.3292 16.8 14.8564V6.01385C16.7962 5.89566 16.7801 5.77817 16.752 5.66324ZM8.016 10.7857L3 6.5784V1.78276C3 1.30995 3.18964 0.856492 3.52721 0.522159C3.86477 0.187826 4.32261 0 4.8 0H12C12.4774 0 12.9352 0.187826 13.2728 0.522159C13.6104 0.856492 13.8 1.30995 13.8 1.78276V6.5784L8.784 10.7857C8.67619 10.8747 8.54031 10.9234 8.4 10.9234C8.25969 10.9234 8.12381 10.8747 8.016 10.7857ZM5.4 3.56553C5.4 3.72313 5.46321 3.87428 5.57574 3.98573C5.68826 4.09717 5.84087 4.15978 6 4.15978H10.8C10.9591 4.15978 11.1117 4.09717 11.2243 3.98573C11.3368 3.87428 11.4 3.72313 11.4 3.56553C11.4 3.40792 11.3368 3.25677 11.2243 3.14533C11.1117 3.03388 10.9591 2.97127 10.8 2.97127H6C5.84087 2.97127 5.68826 3.03388 5.57574 3.14533C5.46321 3.25677 5.4 3.40792 5.4 3.56553ZM6 6.5368H10.8C10.9591 6.5368 11.1117 6.47419 11.2243 6.36275C11.3368 6.2513 11.4 6.10015 11.4 5.94254C11.4 5.78494 11.3368 5.63379 11.2243 5.52234C11.1117 5.4109 10.9591 5.34829 10.8 5.34829H6C5.84087 5.34829 5.68826 5.4109 5.57574 5.52234C5.46321 5.63379 5.4 5.78494 5.4 5.94254C5.4 6.10015 5.46321 6.2513 5.57574 6.36275C5.68826 6.47419 5.84087 6.5368 6 6.5368ZM1.8 3.91614L0.852 4.51039C0.791355 4.55467 0.733264 4.60229 0.678 4.65301L1.8 5.57411V3.91614Z",
          fill: "#8796AF",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }